export const parseFormattedNumber = (str) => {
  return Number.parseInt(str.replace(/\D+/g, ''), 10);
};
